import React, { useContext, useState, useEffect, useMemo } from 'react'
import AuthContext from '../../context/AuthContext'
import Pagination from '../../components/DataTable/pagination'
import Toast from 'react-bootstrap/Toast';
import Modal from 'react-bootstrap/Modal';
import { CSVLink } from "react-csv";
import { handleDeNorm, normalizePhone, deNormalizePhone, handleNorm } from '../../utils/functions/tools/normalizePhone';
const { REACT_APP_DEV_API_URL, REACT_APP_PROD_API_URL, REACT_APP_DEV_MEDIA_URL, REACT_APP_PROD_MEDIA_URL, NODE_ENV } = process.env;
const API_URL =
  NODE_ENV === 'production' ? process.env.REACT_APP_PROD_API_URL : process.env.REACT_APP_DEV_API_URL;
const MEDIA_URL =
  NODE_ENV === 'production' ? process.env.REACT_APP_PROD_MEDIA_URL : process.env.REACT_APP_DEV_MEDIA_URL;

const ProfilePage = ({ match }) => {
  // Variables for pagination
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [ITEMS_PER_PAGE, setITEMS_PER_PAGE] = useState(10);

  // Variables for modals and toasts
  const [show, setShow] = useState(false);
  const [showDeleteNote, setShowDeleteNote] = useState(false);
  const [showAddNoteSuccess, setShowAddNoteSuccess] = useState(false);
  const [showEditNoteSuccess, setShowEditNoteSuccess] = useState(false);
  const [showError, setShowError] = useState(false);
  const [showDeleteNoteError, setShowDeleteNoteError] = useState(false);
  const [showAddNoteError, setShowAddNoteError] = useState(false);
  const [showEditNoteError, setShowEditNoteError] = useState(false);
  const [showNoteAdd, setShowNoteAdd] = useState(false);
  const [showNoteDelete, setShowNoteDelete] = useState(false);
  const [showNoteEdit, setShowNoteEdit] = useState(false);
  const [promptNoteDeleteID, setpromptNoteDeleteID] = useState(null)
  const [editNoteData, setEditNoteData] = useState({ "note": '' })
  const [edittedNote, setEdittedNote] = useState(null)
  let handleNoteAddClose = () => setShowNoteAdd(false);
  let handleShowNoteAdd = () => setShowNoteAdd(true);
  let handleNoteDeleteClose = () => setShowNoteDelete(false);
  let handleShowNoteDelete = () => setShowNoteDelete(true);
  let handleNoteEditClose = () => setShowNoteEdit(false);
  let handleShowNoteEdit = () => setShowNoteEdit(true);

  // Variables for noteSeaarch
  const [noteSearch, setNoteSearch] = useState("");

  // Other Variables
  let { user } = useContext(AuthContext)
  let [authTokens, setAuthTokens] = useState(()=> localStorage.getItem('authTokens') ? JSON.parse(localStorage.getItem('authTokens')) : null)
  let profileId = match.params.id
  let [profile, setProfile] = useState(null)
  let [userDetails, setUserDetails] = useState(null)
  let [userRole, setUserRole] = useState(null)
  let [userPic, setUserPic] = useState(null)
  let [notes, setNotes] = useState([])
  let [inputValue, setInputValue] = useState("");

  let [emailBlank, setEmailBlank] = useState(false)

  let blankError = (val, name) => {
    if (val == "" && name == "email") {
      setEmailBlank(true)
    } else if (name == "email") {
      setEmailBlank(false)
    }
  }

  useEffect(() => {
    getProfile()
    getUserRole()
    getUserPic()
    getNotes()
    document.title = "User Profile | WillowBMS"
  }, [profileId])

  let handleAddNote = async (e) => {
    let response = await fetch(`${API_URL}/usernote/manage/${profileId}/add/`, {
      method: "POST",
      headers: {
        'Content-Type': 'application/json',
        'Authorization':'Bearer ' + authTokens?.access
      },
      body: JSON.stringify({
        'authUser_id': user.id,
        'note': document.getElementById('modal-note').value
      })
    })

    if (response.status === 200) {
      setShowAddNoteSuccess(true)
      getNotes()
      handleNoteAddClose()
    } else {
      setShowAddNoteError(true)
    }
  }

  let handleEditNote = async () => {
    let response = await fetch(`${API_URL}/usernote/manage/edit/${editNoteData.note.id}/`, {
      method: "PUT",
      headers: {
        'Content-Type': 'application/json',
        'Authorization':'Bearer ' + authTokens?.access
      },
      body: JSON.stringify({
        'id': editNoteData.note.id,
        'note': edittedNote.note,
        'authUser': user.id
      })
    })

    if (response.status === 200) {
      setShowEditNoteSuccess(true)
      getNotes()
      setEdittedNote(null)
      handleNoteEditClose()
    } else {
      setShowEditNoteError(true)
    }
  }

  let getProfile = async () => {
    if (profileId === 'new') return

    let response = await fetch(`${API_URL}/profile/${profileId}/`, {
      method: 'GET',
      headers:{
          'Content-Type':'application/json',
          'Authorization':'Bearer ' + authTokens?.access
      }
  })
    let data = await response.json()
    setProfile(data.profile)
    setUserDetails(data)
  }

  const profileDetailsHeaders = [
    { label: "First Name", key: "firstName" },
    { label: "Last Name", key: "lastName" },
    { label: "Email", key: "email" },
    { label: "Phone", key: "phone" }
  ];

  const profileDetailsData = [
    { firstName: userDetails?.first_name, lastName: userDetails?.last_name, email: userDetails?.email, phone: userDetails?.phoneNumber }
  ]

  const csvProfileReport = {
    data: profileDetailsData,
    headers: profileDetailsHeaders,
    filename: `${userDetails?.first_name}${userDetails?.last_name}_user_details.csv`
  };

  const notesHeaders = [
    { label: "ID", key: "id" },
    { label: "Date", key: "date" },
    { label: "Note", key: "note" },
    { label: "User ID", key: "authUser" }
  ];

  const noteReport = {
    data: notes,
    headers: notesHeaders,
    filename: `notes_${userDetails?.first_name}${userDetails?.last_name}_${profileId}_report.csv`
  };

  let getNotes = async () => {
    let response = await fetch(`${API_URL}/usernote/view/${profileId}/`, {
      method: 'GET',
      headers:{
          'Content-Type':'application/json',
          'Authorization':'Bearer ' + authTokens?.access
      }
  })
    let data = await response.json()
    setNotes(data)
  }

  const notesData = useMemo(() => {
    let computedNotes = search(notes);
    setTotalItems(computedNotes.length);
    //Current Page slice
    return computedNotes.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [notes, currentPage, noteSearch]);

  let deleteNote = async (noteID) => {
    let response = await fetch(`${API_URL}/usernote/manage/${noteID}/`, {
      method: 'DELETE',
      'headers': {
        'Content-Type': 'application/json',
        'Authorization':'Bearer ' + authTokens?.access
      }
    })

    if (response.status === 200) {
      setShowDeleteNote(true)
      handleNoteDeleteClose()
      setpromptNoteDeleteID(null)
      getNotes()
    } else {
      setShowDeleteNoteError(true)
    }
  }

  let deleteNotePrompt = async (noteID) => {
    setpromptNoteDeleteID(noteID)
    handleShowNoteDelete()
  }

  let getUserRole = async () => {
    if (profileId === 'new') return

    let response = await fetch(`${API_URL}/userrole/${profileId}/`, {
      method: "GET",
      headers: {
        'Content-Type': 'application/json',
        'Authorization':'Bearer ' + authTokens?.access
      }
    })
    let data = await response.json()
    setUserRole(data)
  }

  let getUserPic = async () => {
    if (profileId === 'new') return

    let response = await fetch(`${API_URL}/userpic/${profileId}/`, {
      method: "GET",
      headers: {
        'Content-Type': 'application/json',
        'Authorization':'Bearer ' + authTokens?.access
      }
    })
    let data = await response.json()
    setUserPic(data)
  }

  let updateUserProfile = async (e) => {
    e.preventDefault();
    let response = await fetch(`${API_URL}/profile/${profileId}/`, {
      method: "PUT",
      headers: {
        'Content-Type': 'application/json',
        'Authorization':'Bearer ' + authTokens?.access
      },
      body: JSON.stringify({
        'id': user.id,
        'user': user.id,
        'first_name': e.target.first_name.value,
        'last_name': e.target.last_name.value,
        'email': e.target.email.value,
        'profile': {
          'phoneNumber': handleDeNorm(e.target.phoneNumber.value),
          'position': e.target.position.value
        }
      })
    })

    if (response.status === 200) {
      setShow(true)
      getProfile()
    } else {
      setShowError(true)
    }
  }

  function search(rows) {
    return rows.filter(
      (row) =>
        row.note.toLowerCase().indexOf(noteSearch) > -1 ||
        row.note.indexOf(noteSearch) > -1 ||
        row.date.toLowerCase().indexOf(noteSearch) > -1
    );
  }

  return (
    <div className="page-wrapper">
      <div className="container-xl">
        <div className="page-header d-print-none">
          <div className="row align-items-center">
            <div className="col">
              <h2 className="page-title">
                Profile{user.id == profileId ? " (You)" : ""}
              </h2>
              <div className="text-muted mt-1">Hi, {user && userDetails?.first_name}!</div>
            </div>
          </div>
        </div>
      </div>
      <div className="page-body">
        <div className="container-xl">
          <div className="row row-cards">
            <div className="col-sm-12 col-md-4">
              <div className="card">
                <div className="card-body p-4 text-center">
                  <span className="avatar avatar-xl mb-3 avatar-rounded" style={{ backgroundImage: `url(${MEDIA_URL}${userPic?.profilePic})` }} />
                  <h3 className="m-0 mb-1"><a href="#">{user && userDetails?.first_name} {user && userDetails?.last_name}</a></h3>
                  <div className="text-muted">{profile?.position}</div>
                  <div className="mt-3">
                    <span className="badge bg-blue-lt">{userRole?.role}</span>
                  </div>
                </div>
                <div>
                  <a href={`mailto:${userDetails?.email}`} className="card-btn col-12">
                    <svg xmlns="http://www.w3.org/2000/svg" className="icon me-2 text-muted" width={24} height={24} viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><rect x={3} y={5} width={18} height={14} rx={2} /><polyline points="3 7 12 13 21 7" /></svg>
                    {user && userDetails?.email}</a>
                  <a href={`tel:${profile?.phoneNumber}`} className="card-btn col-12">
                    <svg xmlns="http://www.w3.org/2000/svg" className="icon me-2 text-muted" width={24} height={24} viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M5 4h4l2 5l-2.5 1.5a11 11 0 0 0 5 5l1.5 -2.5l5 2v4a2 2 0 0 1 -2 2a16 16 0 0 1 -15 -15a2 2 0 0 1 2 -2" /></svg>
                    {user && normalizePhone(profile?.phoneNumber)}</a>
                </div>
              </div>
            </div>
            <div className="col-sm-12 col-md-8">
              <form onSubmit={updateUserProfile} className="card">
                <div className="card-header">
                  <h3 className="card-title">Details</h3>
                  <CSVLink type="button" className="btn btn-outline-primary ms-auto" {...csvProfileReport}>Export to CSV</CSVLink>
                  <button type="submit" className="btn btn-primary ms-2">Save Changes</button>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-xl-12">
                      <div className="row d-flex">
                        <div className="col-md-12 col-xl-6">
                          <div className="mb-3">
                            <label className="form-label">First Name</label>
                            <input type="text" id="first_name" name="first_name" className="form-control" defaultValue={userDetails?.first_name} />
                          </div>
                          <div className="mb-3">
                            <label className="form-label">Last Name</label>
                            <input type="text" id="last_name" name="last_name" className="form-control" defaultValue={userDetails?.last_name} />
                          </div>
                        </div>
                        <div className="col-md-12 col-xl-6">
                          <div className="mb-3">
                            <label className="form-label">Phone Number</label>
                            <input onChange={(e) => handleNorm(e.target.value, e.target.name)} type="text" className="form-control" name="phoneNumber" id="phoneNumber" defaultValue={normalizePhone(profile?.phoneNumber)} />
                          </div>
                          <div className="mb-3">
                            <label className="form-label required">Email Address</label>
                            <input onChange={(e) => { blankError(e.target.value, e.target.name) }} type="email" className={emailBlank == true ? "form-control is-invalid" : "form-control"} name="email" id="email" defaultValue={userDetails?.email} required />
                            {emailBlank == true && <p className='invalid-feedback d-block'>Email address is required</p>}
                          </div>
                        </div>
                        <div className="col-md-12 col-xl-6">
                          <div className="mb-3">
                            <label className="form-label">Position</label>
                            <input type="text" id="position" name="position" className="form-control" defaultValue={profile?.position} />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-footer">
                  <div className="form-hint">
                    <span className="strong">Last Login: </span>
                  </div>
                </div>
              </form>

              {/* NOTES SECTION */}
              <div className="col-12 mt-3">
                <div className="card">
                  <div className="card-header">
                    <h3 className="card-title">Notes</h3>
                    <CSVLink type="button" className="btn btn-outline-primary ms-auto" {...noteReport}>Export to CSV</CSVLink>
                    <button onClick={handleShowNoteAdd} type="button" className="btn btn-primary ms-2">Add Note</button>
                  </div>
                  <div className="card-body border-bottom py-3">
                    <div className="d-flex">
                      <div className="text-muted">
                        Show
                        <div className="mx-2 d-inline-block">
                          <input onChange={(e) => {
                            setITEMS_PER_PAGE(e.target.value)
                            getNotes()
                          }} type="text" className="form-control form-control-sm" value={ITEMS_PER_PAGE} size="3" aria-label="Notes Count" />
                        </div>
                        entries
                      </div>
                      <div className="ms-auto text-muted">
                        Search:
                        <div className="ms-2 d-inline-block">
                          <input value={noteSearch} onChange={(e) => setNoteSearch(e.target.value)} type="text" className="form-control form-control-sm" aria-label="Search Notes" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="table-responsive">
                    <table id="notes" name="notes" className="table card-table table-vcenter datatable">
                      <thead>
                        <tr>
                          <th className="w-1">ID</th>
                          <th>Date</th>
                          <th>Note</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {search(notesData).map((note, index) => (
                          <tr key={index}>
                            <td><span className="text-muted">{note.id}</span></td>
                            <td><a href="#" className="text-reset" tabIndex="-1"></a>{note.date}</td>
                            <td>{note.note}</td>
                            <td className="text-end">
                              <a onClick={() => {
                                setEditNoteData({ note: note })
                                handleShowNoteEdit()
                              }} href="#">Edit</a>
                              <a onClick={() => deleteNotePrompt(note.id)} className="text-danger ms-2" href="#">Delete</a>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  <div className="card-footer d-flex align-items-center">
                    <p className="m-0 text-muted">Total of {notes.length} entries</p>
                    <Pagination
                      total={totalItems}
                      itemsPerPage={ITEMS_PER_PAGE}
                      currentPage={currentPage}
                      onPageChange={page => setCurrentPage(page)}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Toast className="alert alert-success d-flex" onClose={() => setShow(false)} show={show} delay={3000} autohide>
        <div>
          <svg xmlns="http://www.w3.org/2000/svg" className="icon alert-icon" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"></path><path d="M5 12l5 5l10 -10"></path></svg>
        </div>
        <div>
          <h4 className="alert-title">Save Profile</h4>
          <div className="text-muted">Your changes have been saved successfully!</div>
        </div>
      </Toast>
      <Toast className="alert alert-danger" onClose={() => setShowError(false)} show={showError} delay={3000} autohide>
        <div>
          <svg xmlns="http://www.w3.org/2000/svg" className="icon alert-icon" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"></path><circle cx="12" cy="12" r="9"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>
        </div>
        <div>
          <h4 className="alert-title">Save Profile</h4>
          <div className="text-muted">There was a problem saving your changes. Please try again.</div>
        </div>
      </Toast>

      <Toast className="alert alert-success d-flex" onClose={() => setShowEditNoteSuccess(false)} show={showEditNoteSuccess} delay={3000} autohide>
        <div>
          <svg xmlns="http://www.w3.org/2000/svg" className="icon alert-icon" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"></path><path d="M5 12l5 5l10 -10"></path></svg>
        </div>
        <div>
          <h4 className="alert-title">Edit Note</h4>
          <div className="text-muted">Your changes have been saved successfully!</div>
        </div>
      </Toast>
      <Toast className="alert alert-danger" onClose={() => setShowEditNoteError(false)} show={showEditNoteError} delay={3000} autohide>
        <div>
          <svg xmlns="http://www.w3.org/2000/svg" className="icon alert-icon" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"></path><circle cx="12" cy="12" r="9"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>
        </div>
        <div>
          <h4 className="alert-title">Edit Note</h4>
          <div className="text-muted">There was a problem saving your changes. Please try again.</div>
        </div>
      </Toast>

      <Toast className="alert alert-success d-flex" onClose={() => setShowDeleteNote(false)} show={showDeleteNote} delay={3000} autohide>
        <div>
          <svg xmlns="http://www.w3.org/2000/svg" className="icon alert-icon" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"></path><path d="M5 12l5 5l10 -10"></path></svg>
        </div>
        <div>
          <h4 className="alert-title">Delete Note</h4>
          <div className="text-muted">Note has been successfully deleted!</div>
        </div>
      </Toast>
      <Toast className="alert alert-danger" onClose={() => setShowDeleteNoteError(false)} show={showDeleteNoteError} delay={3000} autohide>
        <div>
          <svg xmlns="http://www.w3.org/2000/svg" className="icon alert-icon" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"></path><circle cx="12" cy="12" r="9"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>
        </div>
        <div>
          <h4 className="alert-title">Delete Note</h4>
          <div className="text-muted">There was a problem deleting the note. Please try again.</div>
        </div>
      </Toast>

      <Modal show={showNoteAdd} onHide={handleNoteAddClose}>
        <Modal.Header closeButton>
          <Modal.Title>Add Note</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="col-lg-12">
            <div>
              <label className="form-label">Note</label>
              <textarea id="modal-note" name="modal-note" className="form-control" placeholder="Add your note..." style={{ overflow: 'hidden', overflowWrap: 'break-word', resize: 'none', height: '105.3333px' }}></textarea>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button onClick={handleNoteAddClose} type="button" className="btn btn-outline-primary ms-auto">Close</button>
          <button onClick={handleAddNote} type="button" className="btn btn-primary ms-2">Add Note</button>
        </Modal.Footer>
      </Modal>
      <Modal show={showNoteEdit} onHide={handleNoteEditClose}>
        <Modal.Header closeButton>
          <Modal.Title>Edit Note</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="col-lg-12">
            <div>
              <label className="form-label">Note #{editNoteData.note.id}</label>
              <textarea onChange={(e) => setEdittedNote({ "note": e.target.value })} className="form-control" defaultValue={editNoteData.note.note} style={{ overflow: 'hidden', overflowWrap: 'break-word', resize: 'none', height: '105.3333px' }}></textarea>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button onClick={handleNoteEditClose} type="button" className="btn btn-outline-primary ms-auto">Close</button>
          <button onClick={handleEditNote} type="button" className="btn btn-primary ms-2">Save Changes</button>
        </Modal.Footer>
      </Modal>
      <Modal show={showNoteDelete} onHide={handleNoteDeleteClose}>
        <Modal.Header closeButton>
          <Modal.Title>Delete Note</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="col-lg-12">
            <div>
              <p>Are you sure you want to delete note #{promptNoteDeleteID}?</p>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button onClick={handleNoteDeleteClose} type="button" className="btn btn-outline-primary ms-auto">Close</button>
          <button onClick={() => deleteNote(promptNoteDeleteID)} type="button" className="btn btn-danger ms-2">Delete</button>
        </Modal.Footer>
      </Modal>

      <Toast className="alert alert-success d-flex" onClose={() => setShowAddNoteSuccess(false)} show={showAddNoteSuccess} delay={3000} autohide>
        <div>
          <svg xmlns="http://www.w3.org/2000/svg" className="icon alert-icon" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"></path><path d="M5 12l5 5l10 -10"></path></svg>
        </div>
        <div>
          <h4 className="alert-title">Add Note</h4>
          <div className="text-muted">Note has been successfully added!</div>
        </div>
      </Toast>
      <Toast className="alert alert-danger" onClose={() => setShowAddNoteError(false)} show={showAddNoteError} delay={3000} autohide>
        <div>
          <svg xmlns="http://www.w3.org/2000/svg" className="icon alert-icon" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"></path><circle cx="12" cy="12" r="9"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>
        </div>
        <div>
          <h4 className="alert-title">Add Note</h4>
          <div className="text-muted">There was a problem adding the note. Please try again.</div>
        </div>
      </Toast>
    </div>
  )
}

export default ProfilePage